<template>  
  <div
    class="w-full flex flex-col  relative"
    :class="{'gap-3': isMobileOpen}"
  >
    <div class="block lg:hidden w-full">
      <button
        class="relative btn btn-red w-full flex flex-row justify-center items-center"
        @click="isMobileOpen = !isMobileOpen"
      >
        Kereső
        <img
          src="/img/icons/inputs/dropdown_arrow_icon.svg"
          class="h-[16px] w-[16px] absolute right-4 top-4 transform transition-all group-hover:text-gray-darkest duration-500 "
          :class="{ 
            'rotate-180': isMobileOpen,
          }"
        >
      </button>
    </div>

    <div 
      :class="{ 'max-h-[2000px] opacity-100': isMobileOpen}"
      class="w-full flex flex-col gap-3 max-h-0 lg:max-h-full transition-all duration-500 opacity-0 lg:opacity-100"
    >
      <div class="w-full flex flex-col lg:flex-row gap-3">
        <ReInput
          id="searchtext"
          v-model="form.text"
          placeholder="Keresendő szöveg"
          type="text"
          :has-errors="false"
          icon="/img/pen_icon.svg"
          class="w-full lg:w-2/5"
        />
        <ReSelect
          v-model="form.author"
          :items="authors()"
          placeholder="Szerző"
          :has-errors="false"
          multiple
          has-filter
          class="w-full lg:w-2/5"
        />
        <div class="hidden lg:block lg:w-1/5">
          <button
            type="button"
            class="btn btn-red w-full"
            @click.prevent="submit"
          >
            <i class="fas fa-search" />
          </button>
        </div>
      </div>
      <div class="w-full flex flex-col lg:flex-row gap-3">
        <ReSelect
          v-model="form.editor"
          :items="editors()"
          placeholder="Szerkesztő"
          multiple
          has-filter
          :has-errors="false"
          class="w-full lg:w-1/2"
        />
        <ReSelect
          v-model="form.themes"
          :items="themes()"
          has-filter
          placeholder="Téma"
          :has-errors="false"
          multiple
          class="w-full lg:w-1/2"
        />
        <div class="block lg:hidden w-full">
          <button
            type="button"
            class="btn btn-red w-full"
            @click.prevent="submit"
          >
            <i class="fas fa-search" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReInput from "~/components/rxt/reform/ReInput.vue";
import ReSelect from "~/components/rxt/reform/ReSelect.vue";

export default {
  components: {
    ReInput,
    ReSelect
  },
  props: {
    queryObject: {
      type: Object,
      default: () => {
        return {};
      }
    },
    propMapping: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      isMobileOpen: false,
      showNav: false,
      form: {
        author: [],
        editor: [],
        themes: [],
        text: ""
      }
    };
  },
  computed: {
    years() {
      const years = [];

      for (let i = this.$moment().year(); i >= 1996; i--) {
        years.push(i);
      }

      return years.map(year => {
        return {
          key: this.$unique(),
          value: year,
          text: year
        };
      });
    }
  },
  watch: {
    queryObject(newData) {
      this.makeFormObjectFromQueryObject(newData);
    }
  },
  async fetch() {
    await Promise.all([this.$store.dispatch("loadArticleTypes"),
    this.$store.dispatch("loadArticleAuthors"),
    this.$store.dispatch("loadArticleEditors")])
  },
  beforeMount() {
    this.makeFormObjectFromQueryObject(this.queryObject);
  },
  methods: {
    authors() {
      return this.$store.state.articleAuthors.map(item => {
        return {
          key: this.$unique(),
          value: item.name,
          text: item.name
        };
      });
    },
    editors() {
      return this.$store.state.articleEditors.map(item => {
        return {
          key: this.$unique(),
          value: item.name,
          text: item.name
        };
      });
    },
    themes() {
      return this.$store.state.articleTypes.map(item => {
        return {
          key: this.$unique(),
          value: item.type,
          text: item.type
        };
      });
    },
    submit() {
      const queryObject = {};

      if (this.form.text && this.form.text.length > 0) {
        queryObject["filter[search]"] = this.form.text;
      }
      if (this.form.author.length > 0) {
        queryObject["filter[author]"] = this.form.author.join(",");
      }
      if (this.form.editor.length > 0) {
        queryObject["filter[editor]"] = this.form.editor.join(",");
      }
      if (this.form.themes.length > 0) {
        queryObject["filter[type]"] = this.form.themes.join(",");
      }

      this.$emit("searchChanged", queryObject);
      this.showNav = false;
    },

    makeFormObjectFromQueryObject(newData) {
      const form = {
        author: [],
        editor: [],
        themes: [],
        text: ""
      };

      // set form params for eventsearch component
      if (newData["filter[search]"]) {
        form.text = newData["filter[search]"];
      }

      if (newData["filter[author]"]) {
        form.author = newData["filter[author]"].split(",");
      }

      if (newData["filter[editor]"]) {
        form.editor = newData["filter[editor]"].split(",");
      }

      if (newData["filter[type]"]) {
        form.themes = newData["filter[type]"].split(",");
      }

      this.form = form;
    },
    calculateOffset() {
      return this.modules.length * 5;
    }
  }
};
</script>
